import React from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import buttonStyle from "../../../styles/buttonStyle";
import { useNavigate } from "react-router-dom";
import HeaderBox from "../../../components/HeaderBox";
import InvoiceLabour from "../../../components/Invoice/InvoiceLabour";
import InvoiceParts from "../../../components/Invoice/InvoiceParts";
import DateCalander from '../../../components/DateCalander';

const boxStyle = {
  root: {
    backgroundColor: "white",
    borderRadius: "5px",
    padding: 1,
  },
};

function InvoiceGenaration() {
  const navigate = useNavigate();
  // const [isParts, setIsParts] = useState(false);
  return (
    
            
    <Box mt={2}>
      <Grid container spacing={1}>
      <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> INVOICE GENARATION</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
          <Button  sx={buttonStyle.root} onClick={() => navigate("/Invoice_Bill")}> Save </Button>&nbsp;
              <Button sx={buttonStyle.root} onClick={() => navigate("/Invoice")}> Cancel </Button>
          </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Box>
            <form>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <HeaderBox title="Invoice Genaration" />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={boxStyle.root}>
                    <Grid container spacing={1}>
                    <Grid item xs={1}>
                        <TextField fullWidth size="small" label="Service No" variant="outlined" required name="Service No" disabled/>
                      </Grid>
                      <Grid item xs={1}>
                        <TextField fullWidth size="small" label="Invoice No" variant="outlined" required name="Invoice No" />
                      </Grid>
                      <Grid item xs={1.5} >
                      <DateCalander title='Invoice Date'/>
                      </Grid>
                      <Grid item xs={2}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel id="demo-simple-select-label"> Job No </InputLabel>
                          <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Job No *">
                            <MenuItem value={10}> 2568 </MenuItem>
                            <MenuItem value={20}> 2569 </MenuItem>
                            <MenuItem value={20}> 2570 </MenuItem>
                            <MenuItem value={20}> 2571 </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={2}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel id="demo-simple-select-label"> Payment By </InputLabel>
                          <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Payment By *">
                            <MenuItem value={10}> Card </MenuItem>
                            <MenuItem value={20}> UPI </MenuItem>
                            <MenuItem value={20}> Bank Transfer </MenuItem>
                            <MenuItem value={20}> Cash </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={1.5}>
                      <DateCalander  title='Job Date' />
                      </Grid>
                      <Grid item xs={3}>
                        <TextField fullWidth size="small" label="Outstanding" variant="outlined" required name="Outstanding"/>
                      </Grid>

                      <Grid item xs={12} sm={4} mt={2} >
                      <HeaderBox title="Amount Details" />
                      <Box sx= {{border:'1px solid'}} padding={1} > 
                      <Grid container spacing={1}>
                        <Grid item xs={12} >
                          <Box borderBottom='1px solid'> <span> Total Labour </span></Box>
                        </Grid>
                        <Grid item xs={12} >
                          <Box borderBottom='1px solid'> <span> Total Parts </span></Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box borderBottom='1px solid'> <span> Total Amount </span></Box>
                         </Grid>
                        <Grid item xs={12} >
                          <Box borderBottom='1px solid'> <span> VAT% </span></Box>
                        </Grid>
                        <Grid item xs={12} >
                          <Box borderBottom='1px solid'> <span> Net Amount </span></Box>
                        </Grid>
                        </Grid>
                        </Box>
                    </Grid> 
                    <Grid item xs={12} sm={4} mt={2}>
                    <HeaderBox title="Vehicle Details" />
                    <Box sx= {{border:'1px solid'}} padding={1} >
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <Box borderBottom='1px solid'> <span> VRM </span></Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box borderBottom='1px solid'> <span> VIN </span></Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box borderBottom='1px solid'> <span> Make </span></Box>
                          </Grid>
                          <Grid item xs={12}>
                          <Box borderBottom='1px solid'> <span> Model </span></Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box borderBottom='1px solid'> <span> Vehicle Type </span></Box>
                          </Grid>
                        </Grid>
                        </Box>  
                    </Grid>
                    <Grid item xs={12} sm={4} mt={2}>
                        <HeaderBox title="Customer Address" />
                        <Box sx= {{border:'1px solid'}}  padding={1}> 
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Box borderBottom='1px solid'> <span> Account No </span></Box>
                            </Grid>
                            <Grid item xs={12}>
                              <Box borderBottom='1px solid'> <span> Name </span></Box>
                            </Grid>
                            <Grid item xs={12}>
                              <Box borderBottom='1px solid'> <span> Address </span></Box>
                            </Grid>
                            <Grid item xs={12}>
                              <Box borderBottom='1px solid'> <span> Phone </span></Box>
                            </Grid>
                            <Grid item xs={12}>
                              <Box borderBottom='1px solid'> <span> Mail Id </span></Box>
                            </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
                </Box>
                </Grid>
                <Grid item xs={12} mt={2}>
                  <HeaderBox title="Labour Details" />
                    <Grid item xs={12}>
                        <InvoiceLabour/>
                    </Grid>
                </Grid>
                <Grid item xs={12} mt={1}>
                  <HeaderBox title="Part Details" />
                  <Grid item xs={12}>
                        <InvoiceParts/>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                  
                </Grid>
                {/* <Grid item xs={12}>
                  <SingleAccordion component={<AddPartsTable />} title="Labour Tasks"/>
                </Grid> */}
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default InvoiceGenaration;
